import { jwtDecode } from 'jwt-decode'
import { JWTPayload } from '../redux/app/types'

export const parseJWTToken = (token: string): JWTPayload | null => {
  try {
    const decoded = jwtDecode<JWTPayload>(token)
    return decoded
  } catch (error) {
    console.error('Failed to decode JWT token:', error)
    return null
  }
}

export const extractPlanLimits = (token: string) => {
  const payload = parseJWTToken(token)
  return payload?.plan_limits || null
}

export const extractAvailableModules = (token: string) => {
  const payload = parseJWTToken(token)
  return payload?.available_modules || payload?.modules || []
}

export const extractPricingPlan = (token: string) => {
  const payload = parseJWTToken(token)
  return payload?.pricing_plan || null
}

export const extractUserRole = (token: string) => {
  const payload = parseJWTToken(token)
  return payload?.role || null
}

export const extractStoreInfo = (token: string) => {
  const payload = parseJWTToken(token)
  if (!payload) return null

  return {
    storeId: payload.store_id,
    storeDomain: payload.store_domain,
    storeType: payload.store_type,
    storeVerified: payload.store_verified,
    productCategory: payload.product_category,
    serviceCategory: payload.service_category,
  }
}

export const isTokenExpired = (token: string): boolean => {
  const payload = parseJWTToken(token)
  if (!payload || !payload.exp) return true

  const currentTime = Math.floor(Date.now() / 1000)
  return payload.exp < currentTime
}
